
import { useSelector } from 'react-redux'

import './AccountData.scss'

const AccountData = (props) => {
    const {data} =useSelector((state)=>state.data)
    
  return (
    <div className="account_data">
      <table className="account_table">
        <thead>
            <tr>
                <th>שם בנק</th>
                <th>סניף</th>
                <th>חשבון</th>
            </tr>
        </thead>
        <tbody>
            {data?.accountDetails?.map (acc => (
                <tr>
                    <td>{acc.bankName}</td>
                    <td>{acc.snif}</td>
                    <td>{acc.account}</td>
                </tr>
            ))}
        </tbody>
      </table>
    </div>
    
  )
}

export default AccountData